<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Label Vorgaben konfigurieren"}}</h4>
</div>

<div class="modal-body">
    {{ERROR_ROW errors.error}}
    <div class="row">
        <div class="col-xs-12">
            {{#SELECT pool}}
            <select multiple="multiple" class="multi-select" data-style="btn-white btn-sm" id="msel-pool" name="pool">
                {{#each labels}}
                <option value="{{this}}">{{this}}</option>
                {{/each}}
            </select>
           {{/SELECT}}
        </div>
    </div>
    <div class="row m-t-10">
        <div class="col-xs-12">
            <label class="control-label">{{TR "Neues Label"}}</label>
            <div class="input-group">
                <input type="text" class="form-control input input-sm js-new-label" name="add" value="{{newitem}}" />
                <span class="input-group-btn">
                    <button type="button" {{#unless canAdd}}disabled{{/unless}} class="{{#unless canAdd}}disabled{{/unless}} btn btn-sm btn-white js-btn-add">
                        <i class="fa fa-plus"></i>
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
    <button class="btn btn-primary {{#unless canSave}}disabled{{/unless}}" {{#unless canSave}}disabled{{/unless}} id="js-save">{{TR "Speichern"}}</button>
</div>
